import React, { useState } from "react";
import { auth } from "../../config/firebase";
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";

function Signup({ onSignupSuccess }) {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!form.firstName || !form.lastName || !form.email || !form.password || !form.confirmPassword) {
      setError("All fields are required.");
      return;
    }

    if (form.password !== form.confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, form.email, form.password);
      await updateProfile(userCredential.user, {
        displayName: `${form.firstName} ${form.lastName}`,
      });
      onSignupSuccess(); // back to form view
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="max-w-md mx-auto p-6 border rounded-lg shadow-lg">
      <h2 className="text-2xl font-bold mb-4">Sign Up</h2>
      {error && <p className="text-red-600 mb-2">{error}</p>}
      <form onSubmit={handleSubmit} className="space-y-4">
        <input name="firstName" placeholder="First Name" onChange={handleChange} className="w-full border p-2 rounded" />
        <input name="lastName" placeholder="Last Name" onChange={handleChange} className="w-full border p-2 rounded" />
        <input name="email" placeholder="Email" type="email" onChange={handleChange} className="w-full border p-2 rounded" />
        <input name="password" placeholder="Password" type="password" onChange={handleChange} className="w-full border p-2 rounded" />
        <input name="confirmPassword" placeholder="Confirm Password" type="password" onChange={handleChange} className="w-full border p-2 rounded" />
        <button type="submit" className="bg-green-600 text-white px-4 py-2 rounded w-full">Create Account</button>
      </form>
    </div>
  );
}

export default Signup;
